import { render, staticRenderFns } from "./form.component.vue?vue&type=template&id=48135803&scoped=true&"
import script from "./form.component.vue?vue&type=script&lang=js&"
export * from "./form.component.vue?vue&type=script&lang=js&"
import style0 from "./form.component.vue?vue&type=style&index=0&id=48135803&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48135803",
  null
  
)

export default component.exports